import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import "./index.css";
import { CollectionsSummary, CollectionSpecimenSummary } from "../../../types";
import dayjs from "dayjs";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import CircularProgress from "@mui/material/CircularProgress";
import _ from "lodash";
import { useAppSelector } from "../../../stores/store";
import { parseTimeToLocal } from "../../../utils/timeHelper";
import { parseGenusSpecies } from "../../../utils/stringHelper";

interface props {
  data: CollectionsSummary[];
  isLoading: boolean;
}

const CollectionsSummaryTable: React.FC<props> = ({ data = [], isLoading }) => {
  const collectionSitesOptions = useAppSelector(
    (state) => state.collectionSites.collectionSites
  );
  const trapTypesOptions = useAppSelector(
    (state) => state.collectionSites.trapTypes
  );

  const [speciesList, setSpeList] = useState<string[]>([]);

  useEffect(() => {
    let keyList: string[] = [];
    if (data.length > 0) {
      data.map((cur) =>
        cur.data.map((data) => {
          if (data.displayName)
            keyList.push(data.displayName);
          return "";
        })
      );
      setSpeList(Array.from(new Set(keyList)));
    }
  }, [data]);

  const header = [
    {
      value: "Date",
      key: "createdAt",
      valueParser: (val: string) => parseTimeToLocal(val)
    },
    {
      value: "Collection Name",
      key: "displayName",
      valueParser: (val: string) => val,
    },
    {
      value: "Description",
      key: "description",
      valueParser: (val: string) => val,
    },
    {
      value: "Catch Site",
      key: "collectionSiteId",
      valueParser: (val: string) =>
        collectionSitesOptions.filter((cur) => cur.id === val)[0]
          ?.displayName || "",
    },
    {
      value: "Tray Type",
      key: "trapTypeId",
      valueParser: (val: string) =>
        trapTypesOptions.filter((cur) => cur.id === val)[0]?.displayName || "",
    },
    {
      value: "Collection Date",
      key: "collectionDate",
      valueParser: (val: string) => dayjs(val).format("YYYY-MM-DD HH:mm"),
    },
  ];

  const generateSpeCell = (
    collectionData: CollectionSpecimenSummary[],
    key: string
  ) => {
    if (!key) return (<></>);
    const cur = collectionData.find((cur) => (key && cur.displayName === key));
    if (cur) {return (<>
        <TableCell
              key={cur.count + key + _.uniqueId()}
              align="center"
              className="cell-species-sex cell-species-sex-left cell-species-sex-right"
            >
              {cur.count}
            </TableCell>
          </>);}
      return (<>
        <TableCell
              key={"0_" + key + _.uniqueId()}
              align="center"
              className="cell-species-sex cell-species-sex-left cell-species-sex-right"
            >
              {0}
            </TableCell>
          </>);
  };

  return (
    <Box component="form" className={"runs-detail-form"}>
      {isLoading && (
        <div className="title-collection-summary">
          <Typography>Summary Loading</Typography>
          <CircularProgress />
        </div>
      )}
      {data && !isLoading && (
        <TableContainer component={Paper} className="table-collections-summary">
          <Table>

            <TableHead>
            <TableRow>
              <TableCell align="center" className="cell-species-sex-left" colSpan={2}>
              </TableCell>
              <TableCell  align="center" colSpan={3}>
                <Box sx={{fontWeight: 'bold'}}>Collection Details</Box>
                
              </TableCell>
              <TableCell  align="center" colSpan={1}>
              </TableCell>
              <TableCell className="cell-species-sex-left" align="center" colSpan={Math.max(0, (speciesList.length - 2)/2)}>
              </TableCell>
              <TableCell align="center" colSpan={Math.min(2, speciesList.length)}>
                <Box sx={{fontWeight: 'bold'}}>Species Summary</Box>
              </TableCell>
              <TableCell align="center" className="cell-species-sex-right"colSpan={Math.max(0, (speciesList.length - 2)/2)}>
              </TableCell>
            </TableRow>
              <TableRow>
                {header.map((cur, i) => (
                  <TableCell
                    key={cur.value}
                    align="center"
                    className={`cell-species-sex  cell-species-sex-left`}
                  >
                    <Box sx={{fontWeight: 'bold'}}>{cur.value}</Box>
                  </TableCell>
                ))
                }
                {speciesList.map((cur, i) => (cur) && (
                  <>
                    <TableCell
                      key={cur + " Count"}
                      align="center"
                      className={`cell-species-sex cell-species-sex-left cell-species-sex-right`}
                    >
                      <Box sx={{fontWeight: 'bold', fontStyle: 'italic'}}>{parseGenusSpecies(cur)}</Box>
                    </TableCell>
                  </>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {data.map((collection) => (
                <TableRow key={collection.displayName}>
                  {header.map((cur) => (
                    <TableCell key={cur.value} align="center" className=" cell-species-sex-left">
                      {cur.valueParser(
                        collection[
                          cur.key as keyof CollectionsSummary
                        ] as string
                      )}
                    </TableCell>
                  ))}
                  {speciesList.map((cur) => {
                      return generateSpeCell(collection.data, cur);
                  })}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Box>
  );
};

export default CollectionsSummaryTable;
